'use strict';

angular.module('amexReconciliationApp')
  .component('transactionsOverview', {
    templateUrl: 'scripts/views/components/transactions-overview.html',
    controller: function($stateParams,
                         $state,
                         $scope,
                         TransactionService,
                         LockStatusService,
                         SiteConfigModel,
                         TransactionSearchModel,
                         ActiveTransactionModel,
                         AdobeAnalyticsService,
                         booleanConstants) {
      var self = this;
      var BASE_STATE = 'transactions.overview.';
      var BASE_TITLE = 'transactions.tabs.';
      var STATIC_TITLE = '@work Reconciliation';
      self.booleanConstants = booleanConstants;

      var tabList = {
        tabs: [],
        add: function (state, title, index, analyticsAsset) {
          this.tabs.push({
            state: BASE_STATE + state,
            title: BASE_TITLE + title,
            index: index,
            analyticsAsset: analyticsAsset
          });
        },
        sort: function () {
          this.tabs.sort(function (a, b) {
            return a.index - b.index;
          });
        }
      };

      self.$onInit = function () {
        tabList.add('allocations', 'Accounting',0,'Accounting');
        tabList.add('transaction-details', 'TransactionDetails', 1, 'Transaction Details');
        tabList.add('merchant-info', 'MerchantInfo', 2, 'Merchant Info');
        tabList.add('comments', 'Comments', 3, 'Comments And Additional Data');
        tabList.add('history', 'History', 6, 'History');

        if(SiteConfigModel.isPreAuth()) {
          tabList.add('preauth-data', 'PreAuthData', 4, 'Pre Auth Data');
        }

        if(SiteConfigModel.isBta()) {
          tabList.add('travel-data', 'TravelData', 5, 'Travel Data');
        }

        if(SiteConfigModel.isPo()) {
          tabList.add('purchase-order-details', 'PODetails', 5, 'PO Details');
        }

        if (TransactionService.isMeetings360(ActiveTransactionModel.activeTransaction())) {
          tabList.add('meeting360-details', 'Meeting360Details', 5, 'Meeting 360 Details');
        }

        if(SiteConfigModel.transactionReceiptsEnabled()) {
          tabList.add('receipts', 'Receipts', 7, 'Receipts');
        }

        tabList.sort();
        setCurrentActiveTab();

        $scope.$watch(function () {
          return $state.current.name;
        }, function () {
          setCurrentActiveTab();
        });
      };

      self.activeTransaction = ActiveTransactionModel.activeTransaction;
      self.hasActiveTransaction = ActiveTransactionModel.hasActiveTransaction;
      self.isLimitedRole = TransactionSearchModel.isLimitedRole;

      self.getTabs = function() {
        return tabList.tabs;
      };

      self.isActive = function (tab) {
        return _.isEqual($state.current.name, tab.state);
      };

      self.activeTransactionIsFullyLocked = function () {
        return LockStatusService.isLocked(ActiveTransactionModel.activeTransaction());
      };

      self.hasComments = function hasComments() {
        var transaction = ActiveTransactionModel.activeTransaction();
        var hasMemberComments = !_.isEmpty(_.get(transaction, 'mutableTransactionProperties.cardmemberComments', ''));
        var hasManagerComments = !_.isEmpty(_.get(transaction, 'mutableTransactionProperties.managerComments', ''));
        var isActive = ActiveTransactionModel.hasActiveTransaction();

        return isActive && (hasMemberComments || hasManagerComments);
      };

      self.refreshUrl = function() {
        return '/#/' + $stateParams.currentRole;
      };

      self.trackAdobeAnalytics = function(tab) {
        updateTabNameForAnalytics(tab);
        AdobeAnalyticsService.eventTrack('click',{'eventAsset':tab.analyticsAsset});
      };

      function updateTabNameForAnalytics(tab) {
        let fullState= (tab && tab.state) ? tab.state : undefined;
        if(!fullState || fullState.length === 0) {
          return ;
        }
        var ind = fullState.lastIndexOf('.');
        if(ind === -1) {
          return;
        }
        var subPath = fullState.substring(ind+1);
        AdobeAnalyticsService.setActiveTabForAnalytics(subPath);
      }

      function setCurrentActiveTab() {
        let activeTab;
        for (let i = 0; i < tabList.tabs.length; i++) {
          if (self.isActive(tabList.tabs[i])) {
            activeTab = tabList.tabs[i];
            break;
          }
        }
        if (activeTab) {
          const formattedtitle = STATIC_TITLE + ' - ' + activeTab.analyticsAsset;
          $scope.pageTitle = formattedtitle;
          document.title = formattedtitle;
        } else {
          $scope.pageTitle = STATIC_TITLE;
          document.title = STATIC_TITLE;
        }
      }

      $scope.$on('$stateChangeSuccess', function () {
        setCurrentActiveTab();
      });

    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/TransactionsOverview.js
// module id = 424
// module chunks = 0